import { Link } from "react-router-dom";
import Image from "../../images/picture5_50.png";
import { useTranslation } from "react-i18next";
import "./mainHeader.css";

const MainHeader = () => {
  const { t } = useTranslation();
  return (
    <header className="main__header">
      <div className="container main__header-container">
        <div className="main__header-left">
          <h4>{t("sub_title_head")}</h4>
          <h1>{t("title_head")}</h1>
          <p>{t("head_desc")}</p>
          <Link to="/products" className="btn lg">
            {t("see_btn")}
          </Link>
        </div>
        <div className="main__header-right">
          <div className="main__header-circle"></div>
          <div className="main__header-image">
            <img src={Image} alt="Main Header" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default MainHeader;
